import { IMarketoField } from 'marketing-site/lib/marketo/@types/fields'
import { IFormValues } from 'marketing-site/src/library/elements/Form'
import getFormInitialValues from 'marketing-site/src/library/elements/Form/utils/getInitialValues'
import transformMarketoFields from './transformFields/transformMarketoFields'

export default function getInitialValues(
  fields: IMarketoField[],
  sendEmptyValues = true,
): IFormValues {
  const formFields = transformMarketoFields(fields)
  return getFormInitialValues(formFields, undefined, sendEmptyValues)
}
